var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dk-accordion",class:{
        'tw-text-white': _vm.isNegative,
        'tw-border-b tw-border-solid tw-border-slate-100': _vm.hasBorders && !_vm.isVehicleCard,
        'tw-mt-4': _vm.isVehicleCard,
    }},[_c('button',{staticClass:"dk-accordion__button tw-flex tw-items-center tw-w-full tw-font-semibold tw-py-4 tw-cursor-pointer",class:{
            'body-md': _vm.isLarge,
            'hover:tw-text-slate-300': _vm.isNegative && !_vm.isAccordionCard,
            '!tw-w-fit !tw-justify-start tw-text-brand-primary tw-text-sm !tw-p-0 tw-font-semibold': _vm.isVehicleCard,
            '!tw-pt-3 !tw-pb-4 lg:!tw-pt-[22px] lg:!tw-pb-6': _vm.isAccordionCard && _vm.isExpanded,
            '!tw-py-2': _vm.isAccordionCard && !_vm.isExpanded,
            'lg:tw-py-3': _vm.isVersionCard,
            'lg:tw-pt-3 lg:tw-pb-6': _vm.isVersionCard && _vm.isExpanded,
        },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle($event)}}},[(_vm.$slots.title)?_c('span',[_vm._t("title")],2):_c('span',{class:{ 'tw-mr-2': _vm.isVehicleCard, 'tw-mr-3': !_vm.isVehicleCard },domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('dk-icon',{staticClass:"tw-ml-auto",class:{
                'tw-rotate-180': _vm.isExpanded,
                'tw-mr-4 lg:tw-mr-6': _vm.isAccordionCard && !_vm.isVersionCard,
            },attrs:{"name":"ds-chevron-down","size":_vm.isVehicleCard ? 'xs' : _vm.isVersionCard ? 'm' : 's'}})],1),(_vm.hasContent)?_c('div',{staticClass:"dk-accordion__content",class:{
            'tw-hidden': !_vm.isExpanded,
            'tw-mb-4': _vm.hasBorders,
            'tw-mt-[20px]': _vm.isVehicleCard,
        }},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }